import React from 'react'
import { InfoOutlined, LocalShippingOutlined, Person, SmsOutlined, TextSnippetOutlined } from "@mui/icons-material";
import { Box, Grid } from "@mui/material";

import InformationTile from "components/Shared/InformationTile";
import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";
import Status from "components/Shared/Status";

import { useCommunicationDetailContext } from "contexts/CommunicationDetailContext";


const CommunicationBasicDetail = () => {

  const { communicationDetail, loadingCommunication } =
    useCommunicationDetailContext();

  return !loadingCommunication ? (
    <Box padding={3}>
      <Grid container spacing={4}>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <SmsOutlined color="primary" />}
            title="Communication ID"
            subtitle={communicationDetail?.communicationId}
          />
        </Grid>
        <Grid item xs={4}>
          <InformationTile
            icon={() => <LocalShippingOutlined color="primary" />}
            title="Shipment ID"
            subtitle={
              communicationDetail?.shipmentId && typeof communicationDetail.shipmentId === "object"
                ? communicationDetail?.shipmentId?.shipmentId
                : communicationDetail?.shipmentId
            }
          />
        </Grid>
        <Grid item xs={4}>
          <InformationTile
            icon={() => <Person color="primary" />}
            title="Sender System"
            subtitle={communicationDetail?.senderSystem}
          />
        </Grid>
        <Grid item xs={4}>
          <InformationTile
            icon={() => <Person color="primary" />}
            title="Receiver System"
            subtitle={communicationDetail?.receiverSystem}
          />
        </Grid>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <TextSnippetOutlined color="primary" />}
            title="Message"
            subtitle={communicationDetail?.message}
          />
        </Grid>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <SmsOutlined color="primary" />}
            title="Communication Type"
            subtitle={communicationDetail?.communicationType}
          />
        </Grid>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Status"
            subtitle={communicationDetail?.status}
          />
        </Grid>
        <Grid item xs={4}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="isActive"
          >
            <Status isActive={communicationDetail?.isActive} />
          </InformationTile>
        </Grid>
      </Grid>
    </Box>
  ) : (
    <InfoGridSkeleton />
  )
}

export default CommunicationBasicDetail